<template>
    <v-container fluid :style="{'background-color':$store.getters.getColorPalette().backgroundColorCode}">
        <v-row>
            <v-col cols="12" align="center">
                <ComboParamTable />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import ComboParamTable from '@/components/lists/derived/ComboParamTable'
export default {
    name:'ComboParamPage',
    components:{
        ComboParamTable
    }
}
</script>